import { render, staticRenderFns } from "./QuickAppPrivacyProtocol.vue?vue&type=template&id=737d655c&scoped=true"
import script from "./QuickAppPrivacyProtocol.vue?vue&type=script&lang=js"
export * from "./QuickAppPrivacyProtocol.vue?vue&type=script&lang=js"
import style0 from "./QuickAppPrivacyProtocol.vue?vue&type=style&index=0&id=737d655c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737d655c",
  null
  
)

export default component.exports